import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDna, faMicroscope, faFlask } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "CRISPR-Cas9",
    "RT-PCR",
    "Gene Editing",
    "DNA Sequencing",
    "Cell Culture",
    "Western Blot",
    "ELISA",
    "Flow Cytometry",
    "qPCR",
    "Molecular Cloning",
    "Plasmid Design",
  ];
  
const labelsSecond = [
    "Fermentation",
    "Bioprocessing",
    "Downstream Processing",
    "cGMP Compliance",
    "Quality Control",
    "Scale-up",
    "Bioreactor Operations",
    "Purification",
    "Viral Vector Production",
];

const labelsThird = [
"NGS Analysis",
"Bioinformatics",
"Genomic Data",
"Proteomics",
"Metabolomics",
"Machine Learning",
"Image Analysis",
"Biostatistics"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Core Techniques</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faDna} size="3x"  className="icon-gap"/>
                    <FontAwesomeIcon icon={faMicroscope} size="3x"/>

                    <h3>Molecular Biology & Genetics</h3>
                    <p>Specializing in advanced genetic manipulation, I design and execute precision experiments using CRISPR technology, RT-PCR, and DNA sequencing to engineer biological systems and unlock new therapeutic pathways.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Key techniques:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faFlask} size="3x"  className="icon-gap"/>
                    <FontAwesomeIcon icon={faMicroscope} size="3x"/>
                    <h3>Bioprocessing & Biomanufacturing</h3>
                    <p>I develop scalable bioproduction workflows from upstream fermentation to downstream purification, ensuring cGMP compliance while optimizing yield and purity for therapeutic biologics and viral vectors.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Key techniques:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDna} size="3x" className="icon-gap"/>
                    <FontAwesomeIcon icon={faMicroscope} size="3x"/>
                    <h3>Bioinformatics & Data Science</h3>
                    <p>I leverage computational tools for NGS data analysis, biomolecular modeling, and machine learning to extract meaningful patterns from complex biological datasets and accelerate discovery.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Key techniques:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;